import React, { useEffect } from "react";

const Widget = () => {
  const open = () => {
    const widgetUrl = `${window.location.origin}/widget`;
    const winFeature =
      "width=500,height=42,resizable=yes,location=no,toolbar=no,menubar=no,titlebar=no,scrollbars=no,status=no";
    const newWindow = window.open(widgetUrl, "_blank", winFeature);

    if (newWindow) {
      setTimeout(() => {
        newWindow.resizeTo(120, 120);
        const adjustSize = () => {
          newWindow.resizeTo(500, 116);
        };
        setTimeout(adjustSize, 50);
      }, 50);
    }

    if (!newWindow) {
      console.error("Failed to open new window. Pop-up might be blocked.");
      return;
    }

    newWindow.onload = () => {
      console.log("New window loaded at", widgetUrl);
    };
  };

  useEffect(() => {
    open();
  }, []);

  return <div className="cw-widget-pop" id="cw-widget-pop-id"></div>;
};

export default Widget;
